// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"91":"e0ac5863","845":"6f92b556"}[chunkId] + ".css";
};